/* Mudan — motion layer (botanical slow-luxury)
   Native, dependency-free. Scroll reveals + gentle hero parallax.
   Respects prefers-reduced-motion. Safe to run on every page. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var main = document.querySelector('main') || document.body;

    /* 1. Tag top-level sections for staggered reveal */
    var sections = main.querySelectorAll(':scope > .shopify-section');
    sections.forEach(function (sec, i) {
      // Skip the hero — it should be visible immediately (above the fold)
      if (sec.querySelector('.hero, [class*="hero"]') && i === 0) return;
      sec.setAttribute('data-mudan-reveal', '');
    });

    if (reduce || !('IntersectionObserver' in window)) {
      main.querySelectorAll('[data-mudan-reveal]').forEach(function (el) {
        el.classList.add('mudan-in');
      });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('mudan-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      main.querySelectorAll('[data-mudan-reveal]').forEach(function (el) {
        io.observe(el);
      });
    }

    /* 2. Gentle hero parallax */
    if (!reduce) {
      var hero = main.querySelector('.shopify-section:first-child .hero__media, .shopify-section:first-child [class*="hero"] img, .shopify-section:first-child [class*="hero"] video');
      if (hero) {
        hero.setAttribute('data-mudan-parallax', '');
        var ticking = false;
        window.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            var y = window.scrollY || window.pageYOffset;
            if (y < 1000) {
              hero.style.transform = 'translate3d(0,' + (y * 0.14).toFixed(1) + 'px,0)';
            }
            ticking = false;
          });
        }, { passive: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init in the theme editor when sections are added/reordered */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      setTimeout(init, 50);
    });
  }
})();
